module.exports = __webpack_public_path__ + "media/public/img/landing_page/hiw1-rp-e98e4f1804d115616f8c553c3111f097.jpg";